import { zodResolver } from "@hookform/resolvers/zod";
import { useSetAtom } from "jotai";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	type FilterFormValues,
	getFilterFormSchema,
} from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import { useEffectivePortfolioFilter } from "web_myplann/Portfolio/Hooks/useEffectivePortfolioFilter";
import {
	defaultPortfolioFilterState,
	portfolioFilterState,
} from "web_myplann/Shared/State/portfolioFilterAtom";

export const useFilterForm = () => {
	const navigate = useNavigate();
	const setFilter = useSetAtom(portfolioFilterState);
	const { filter } = useEffectivePortfolioFilter();

	const form = useForm<FilterFormValues>({
		resolver: zodResolver(getFilterFormSchema()),
		defaultValues: filter,
		mode: "onChange",
	});

	const onSubmit = form.handleSubmit((values) => {
		setFilter(values);
		navigate(Routing.Portfolio.PortfolioList.path());
	});

	const reset = () => form.reset(defaultPortfolioFilterState);

	return { form, onSubmit, reset };
};
